import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../shared';

// ─────────────────────────────────────────────────────────────────────────────
// MapaTab — jugadores online sobre el mapa de mundo abierto (GET /api/admin/map/players)
// Lienzo canonico 1024x600 (resolucion nativa del futuro panel ESP32): los
// px/py que manda el backend ya estan en ese espacio, aqui solo se posicionan
// en porcentaje para que el contenedor escale de forma responsive.
const MAP_CONTINENTS = [
  { key: 'azeroth',   label: 'Azeroth' },
  { key: 'outland',   label: 'Outland' },
  { key: 'northrend', label: 'Northrend' },
];

export default function MapaTab({ refreshTick = 0 }) {
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError]       = useState(null);
  const [continent, setContinent] = useState('azeroth');
  const [imgOk, setImgOk]       = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchSnapshot = () => {
      axios.get(`${BACKEND_URL}/api/admin/map/players`, { withCredentials: true })
        .then(({ data }) => { if (!cancelled) { setSnapshot(data); setError(null); } })
        .catch((err) => { if (!cancelled) setError(err?.response?.data?.error?.message || 'No se pudo cargar el mapa'); });
    };
    fetchSnapshot();
    const id = setInterval(fetchSnapshot, 10000);
    return () => { cancelled = true; clearInterval(id); };
  }, [refreshTick]); // el boton de refresco global (RefreshCw) incrementa refreshTick para forzar una recarga inmediata

  const players = (snapshot?.players || []).filter((p) => p.continent === continent);

  return (
    <div className="admin-section anim-fade-up" style={{ animationDelay: '0.1s' }}>
      <div className="admin-section-header">
        <h2 className="admin-section-title">Mapa de jugadores</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          {MAP_CONTINENTS.map((c) => (
            <button
              key={c.key}
              onClick={() => { setContinent(c.key); setImgOk(true); }}
              style={{
                background: continent === c.key ? 'linear-gradient(135deg,#0077b6,#00b4d8)' : 'rgba(0,229,255,0.06)',
                border: '1px solid rgba(0,229,255,0.25)', borderRadius: 8,
                color: '#e0f7ff', fontSize: 12, fontWeight: 700, padding: '8px 16px', cursor: 'pointer',
              }}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      {error && (
        <div style={{ color: '#f87171', fontSize: 13, marginBottom: 12 }}>{error}</div>
      )}

      <div
        style={{
          position: 'relative', width: '100%', maxWidth: 1024, aspectRatio: '1024 / 600',
          background: '#0a0f1a', border: '1px solid rgba(0,229,255,0.15)', borderRadius: 12,
          overflow: 'hidden', margin: '0 auto',
        }}
      >
        {imgOk ? (
          <img
            src={`/maps/${continent}.jpg`}
            alt={continent}
            onError={() => setImgOk(false)}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        ) : (
          <div style={{
            width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'rgba(224,247,255,0.4)', fontSize: 13, textAlign: 'center', padding: 24,
          }}>
            Falta la imagen /maps/{continent}.jpg (1024×600). Colócala en frontend/public/maps/ para ver el mapa.
          </div>
        )}

        {players.map((p) => (
          <div
            key={p.name}
            title={`${p.name} (${p.level}) — ${p.class_name} — ${p.zone_name}`}
            style={{
              position: 'absolute',
              left: `${(p.px / 1024) * 100}%`,
              top: `${(p.py / 600) * 100}%`,
              width: 8, height: 8, borderRadius: '50%',
              background: p.class_color,
              border: `1px solid ${p.faction === 'horde' ? '#f87171' : '#69CCF0'}`,
              boxShadow: '0 0 4px rgba(0,0,0,0.6)',
              transform: 'translate(-50%, -50%)',
              cursor: 'default',
            }}
          />
        ))}
      </div>

      <p style={{ color: 'rgba(224,247,255,0.35)', fontSize: 12, marginTop: 10 }}>
        {snapshot ? `${players.length} jugadores en ${MAP_CONTINENTS.find((c) => c.key === continent)?.label}` : 'Cargando…'}
        {snapshot?.truncated && ' · lista recortada al límite máximo'}
      </p>
    </div>
  );
}
